import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "fill-rule": "none",
  viewBox: "0 0 256 256"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "#fff",
      "stroke-miterlimit": "10",
      "font-family": "none",
      "font-size": "none",
      "font-weight": "none",
      style: {"mix-blend-mode":"normal"},
      "text-anchor": "none"
    }, [
      _createElementVNode("path", {
        "fill-rule": "nonzero",
        d: "M218.667 32 52.955 224H33.147L198.864 32z"
      }),
      _createElementVNode("path", {
        "fill-rule": "evenodd",
        d: "M166.096 218.667 41.706 37.333h47.771l124.39 181.334z"
      }),
      _createElementVNode("path", {
        "fill-rule": "nonzero",
        d: "m83.861 48 109.75 160h-21.9L61.964 48zm8.427-16H31.584l131.701 192h60.704z"
      })
    ], -1)
  ])))
}
export default { render: render }